module.exports = __webpack_public_path__ + "img/mountain-version.755c4efb.jpg";